import React, { Component } from "react";
import $ from "jquery";
import * as Common from "../CommonControlls/CommonJs";
import MainLayout from "../CommonControlls/MainLayout";
import Topmenu from "../CommonControlls/Topmenubar";
import { connect } from "react-redux";
import Table from "../CommonControlls/TableRendrer";
import { Link } from "react-router-dom";
import { SelectAllBanks } from "../OfflineDb/IndexDbTranscSP";
import AlertModal from "../CommonControlls/AlertModal";
import DropDown from "../CommonControlls/DropdownRendrer";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import jsPDF from "jspdf";

const mapStateToProps = (store) => {
    return store;
};

const mapDispatchToProps = (dispatch) => {
    return {
        ShowAlert: (Settings) => {
            dispatch({ type: "UpdateAlert", payload: Settings });
        },
        ShowLoader: (Isloading) => {
            dispatch({ type: "UpdateLoader", payload: Isloading });
        },
    };
};

class HcfIncentives extends Component {
    constructor(props) {
        super(props);

        this.hcfInfoRef = React.createRef();
        this.batchRef = React.createRef();

        this.state = {
            // Table
            data: [],
            page: 1,
            sizePerPage: 2000,
            TotalRecord: 0,
            loading: false,
            exportLoading: false,

            sortField: "id",
            idsortOrder: "desc",
            provinceNamesortOrder: "",
            districtNamesortOrder: "",
            gxTestResultssortOrder: "",

            permissions: [],

            alertModalData: {
                title: "",
                message: "",
                First_Callback: () => { },
                Second_Callback: () => { },
                type: 1,
            },

            ProvinceLoader: false,
            Provincelist: [],
            ProvinceId: [],

            DistrictLoader: false,
            Districtlist: [],
            FilteredDistrictlist: [],
            DistrictId: [],

            TehsilLoader: false,
            Tehsillist: [],
            FilteredTehsillist: [],
            TehsilId: [],

            RiderLoader: false,
            Riderslist: [],
            SrList: [],
            SrId: [],
            FilteredSrs: [],
            RiderId: 0,
            riderInfo: "",

            startDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1), // Current month's first day
            endDate: new Date(),

            Banklist: [],
            BankId: 0,
            BankLoader: false,

            selectedRows: [],
        };
    }

    HandleDateChange = (Field, date) => {
        this.setState(
            { [Field]: date === "" || date == null ? new Date() : date },
            () => {
                if (
                    Field === "startDate" &&
                    this.state.startDate > this.state.endDate
                ) {
                    this.setState({ endDate: this.state.startDate });
                }
            }
        );
    };
    HandleAutoSuggestValChange = (fieldId, value) => {
        const emptyRidersList = () => this.setState({ Riderslist: [] });
        this.setState(
            {
                [fieldId]: value,
                // isSaveSearch: this.state.isSearchChanged ? true : false
            },
            () => {
                if (fieldId === "ProvinceId") {
                    this.FilterDistricts(value);
                    if (!value[0]) emptyRidersList();
                }
                if (fieldId === "DistrictId") {
                    this.FilterTehsils(value);
                    if (!value[0]) emptyRidersList();
                }
                if (fieldId === "TehsilId") {
                    if (value[0]) this.SelectRiders();
                    else emptyRidersList();
                }
            }
        );
    };

    SelectRiders = () => {
        this.setState({ RiderLoader: true });

        var provinceId =
            this.state.ProvinceId.length === 0
                ? ""
                : "," + Common.convertToCommaString(this.state.ProvinceId, "id") + ",";
        var districtId =
            this.state.DistrictId.length === 0
                ? ""
                : "," + Common.convertToCommaString(this.state.DistrictId, "id") + ",";
        var tehsilId =
            this.state.TehsilId.length === 0
                ? ""
                : "," + Common.convertToCommaString(this.state.TehsilId, "id") + ",";

        Common.Ajax(
            this.props.UserAuthentication.AuthToken,
            "GET",
            false,
            Common.APILinks.Select_MultipleRiderProfiles,
            {
                sortField: "id",
                sortOrder: "asc",
                provinceId,
                districtId,
                tehsilId,
            },
            (response) => {
                this.setState({
                    Riderslist: response.data,
                    RiderLoader: false,
                });
            }
        );
    };
    FilterDistricts = (value) => {
        // filter ditrict list
        var TempArr = this.state.Districtlist;
        var selectedProvince = Common.ConvertToCommaSplitArray(value, "id");
        var filteredDistrictList = TempArr.filter(function (obj) {
            return selectedProvince.indexOf(obj.provinceId) > -1;
        });

        // filter district selected values
        var selectedDistricts = this.state.DistrictId;
        var filteredDistrictIdArr = Common.ConvertToCommaSplitArray(
            filteredDistrictList,
            "id"
        );
        var filteredSelectedDistricts = selectedDistricts.filter(function (obj) {
            return filteredDistrictIdArr.indexOf(obj.id) > -1;
        });

        const TempSr = this.state.SrList;
        const filtered = TempSr.filter((el) => {
            return selectedProvince.indexOf(el.provinceid) > -1;
        });

        this.setState({
            FilteredSrs: filtered,
            FilteredDistrictlist: filteredDistrictList,
            DistrictId: filteredSelectedDistricts,
        });
    };
    FilterTehsils = (value) => {
        // filter Tehsil list
        var TempArr = this.state.Tehsillist;
        var selectedVale = Common.ConvertToCommaSplitArray(value, "id");
        var filteredTehsilList = TempArr.filter(function (obj) {
            return selectedVale.indexOf(obj.districtId) > -1;
        });

        // filter Tehsil selected values
        var selectedTehsils = this.state.TehsilId;
        var filteredTehsilIdArr = Common.ConvertToCommaSplitArray(
            filteredTehsilList,
            "id"
        );
        var filteredSelectedTehsils = selectedTehsils.filter(function (obj) {
            return filteredTehsilIdArr.indexOf(obj.id) > -1;
        });

        this.setState({
            FilteredTehsillist: filteredTehsilList,
            TehsilId: filteredSelectedTehsils,
        });
    };

    handleRowSelect = (row, isSelect, rowIndex, e) => {
        const { selectedRows } = this.state;

        if (isSelect) {
            this.setState({ selectedRows: [...selectedRows, row.id] });
        } else {
            this.setState({
                selectedRows: selectedRows.filter((selectedId) => selectedId !== row.id),
            });
        }
    };

    handleColumnSort = (fieldName) => {
        let tempFieldorderLabel = fieldName + "sortOrder";
        let tempFieldorder =
            this.state[tempFieldorderLabel] == ""
                ? "asc"
                : this.state[tempFieldorderLabel] == "asc"
                    ? "desc"
                    : "asc";
        this.setState(
            {
                sortField: fieldName,
                [tempFieldorderLabel]: tempFieldorder,
            },
            () => {
                this.PopulateTable();
            }
        );
    };

    getSortIcon = (fieldName) => {
        const sortOrder = this.state[fieldName + "sortOrder"];
        if (sortOrder === "asc") {
            return <i className="fa fa-sort-up" style={{ marginLeft: "5px" }}></i>;
        } else if (sortOrder === "desc") {
            return <i className="fa fa-sort-down" style={{ marginLeft: "5px" }}></i>;
        } else {
            return <i className="fa fa-sort" style={{ marginLeft: "5px", color: "#ccc" }}></i>;
        }
    };


    render() {
        function avatarformatter(cell, row) {
            return <span>{row.name}</span>;
        }

        function footerFormatter(column, colIndex, { text }) {
            return (
                <strong title={column.text}>{text}</strong>
            );
        }

        const columns = [
            {
                text: "Sr. #",
                export: true,
                footer: "",
                formatter: (cell, row, rowIndex) => {
                    return rowIndex + 1;
                },
                csvFormatter: (cell, row, rowIndex) => {
                    return rowIndex + 1;
                },
                headerStyle: (colum, colIndex) => {
                    return { width: "75px", fontSize: "13px" };
                },
            },

            {
                dataField: "provinceName",
                text: "Province",
                sort: true,
                export: true,
                footer: "",
                headerStyle: (colum, colIndex) => {
                    return { width: "150px", fontSize: "13px" };
                },
                // sort: true,
            },
            {
                dataField: "districtName",
                text: "District",
                sort: true,
                export: true,
                footer: "",
                headerStyle: (colum, colIndex) => {
                    return { width: "90px", fontSize: "13px" };
                },
            },
            {
                dataField: "subRecipientShortName",
                text: "SR",
                sort: true,
                export: true,
                footer: "",
                headerStyle: (colum, colIndex) => {
                    return { width: "90px", fontSize: "13px" };
                },
            },
            {
                dataField: "hcfName",
                text: " Health Care Facilities (HCF)",
                sort: true,
                export: true,
                footer: "",
                headerStyle: (colum, colIndex) => {
                    return { width: "150px", fontSize: "13px" };
                },
                // sort: true,
            },
            {
                dataField: "category",
                text: "Category",
                sort: true,
                export: true,
                footer: "",
                headerStyle: (colum, colIndex) => {
                    return { width: "150px", fontSize: "13px" };
                },
            },
            {
                dataField: "focalPerson",
                text: "Focal Person",
                sort: true,
                export: true,
                footer: "",
            },
            {
                dataField: "contactNo",
                text: "Contact #",
                sort: true,
                export: true,
                footer: "",
                headerStyle: (colum, colIndex) => {
                    return { width: "100px", fontSize: "13px" };
                },
            },
            {
                dataField: "cnic",
                text: "CNIC",
                sort: true,
                export: true,
                footer: "",
                headerStyle: (colum, colIndex) => {
                    return { width: "100px", fontSize: "13px" };
                },
            },
            {
                dataField: "bpuGpSamples",
                text: "Samples by GP & BHU",
                sort: true,
                style: {
                    textAlign: 'right',
                },
                export: true,
                footer: (columnData) => columnData.reduce((acc, item) => acc + item, 0).toLocaleString('en-GB'),
                footerFormatter: footerFormatter,
                headerStyle: (colum, colIndex) => {
                    return { width: "80px", fontSize: "13px" };
                },
            },
            {
                dataField: "ppmRhcSamples",
                text: "Samples by PPM & RHC",
                sort: true,
                style: {
                    textAlign: 'right',
                },
                export: true,
                footer: (columnData) => columnData.reduce((acc, item) => acc + item, 0).toLocaleString('en-GB'),
                footerFormatter: footerFormatter,
                headerStyle: (colum, colIndex) => {
                    return { width: "80px", fontSize: "13px" };
                },
            },
            {
                dataField: "afbHcfTestResults",
                text: "AFB by HCF for GP & BHU",
                sort: true,
                style: {
                    textAlign: 'right',
                },
                export: true,
                footer: (columnData) => columnData.reduce((acc, item) => acc + item, 0).toLocaleString('en-GB'),
                footerFormatter: footerFormatter,
                headerStyle: (colum, colIndex) => {
                    return { width: "80px", fontSize: "13px" };
                },
            },
            {
                dataField: "afbXpertTestResults",
                text: "AFB by GX Sites for GP & BHU",
                sort: true,
                style: {
                    textAlign: 'right',
                },
                export: true,
                footer: (columnData) => columnData.reduce((acc, item) => acc + item, 0).toLocaleString('en-GB'),
                footerFormatter: footerFormatter,
                headerStyle: (colum, colIndex) => {
                    return { width: "80px", fontSize: "13px" };
                },
            },
            {
                dataField: "gxTestResults",
                text: "GX Test Results",
                sort: false,
                style: {
                    textAlign: 'right',
                },
                export: true,
                footer: (columnData) => columnData.reduce((acc, item) => acc + item, 0).toLocaleString('en-GB'),
                footerFormatter: footerFormatter,
                headerStyle: (colum, colIndex) => {
                    return { width: "80px", fontSize: "13px", cursor: "pointer" };
                },
                headerFormatter: (column, colIndex, { sortElement, filterElement }) => {
                    return (
                        <div
                            onClick={() => this.handleColumnSort("gxTestResults")}
                            style={{ cursor: "pointer" }}
                        >
                            GX Test Results {this.getSortIcon("gxTestResults")}
                        </div>
                    );
                },
            },
            {
                dataField: "totalSamplesAndTestResults",
                text: "Total Samples And Test Results",
                sort: true,
                style: {
                    textAlign: 'right',
                },
                export: true,
                footer: (columnData) => columnData.reduce((acc, item) => acc + item, 0).toLocaleString('en-GB'),
                footerFormatter: footerFormatter,
                headerStyle: (colum, colIndex) => {
                    return { width: "120px", fontSize: "13px" };
                },
            },
            {
                dataField: "totalIncentiveSampleOrTestResult",
                text: "Total Incentive Sample Or Test Result",
                sort: true,
                style: {
                    textAlign: 'right',
                },
                export: true,
                footer: (columnData) => columnData.reduce((acc, item) => acc + item, 0).toLocaleString('en-GB'),
                footerFormatter: footerFormatter,
                headerStyle: (colum, colIndex) => {
                    return { width: "80px", fontSize: "13px" };
                },
            },
            {
                dataField: "withholdingTax",
                text: "WHT @ 8%/4%",
                sort: true,
                style: {
                    textAlign: 'right',
                },
                export: true,
                footer: (columnData) => columnData.reduce((acc, item) => acc + item, 0).toLocaleString('en-GB'),
                footerFormatter: footerFormatter,
                headerStyle: (colum, colIndex) => {
                    return { width: "80px", fontSize: "13px" };
                },
            },
            {
                dataField: "gst",
                text: "GST @ 5%",
                sort: true,
                style: {
                    textAlign: 'right',
                },
                export: true,
                footer: (columnData) => columnData.reduce((acc, item) => acc + item, 0).toLocaleString('en-GB'),
                footerFormatter: footerFormatter,
                headerStyle: (colum, colIndex) => {
                    return { width: "80px", fontSize: "13px" };
                },
            },
            {
                dataField: "totalTaxes",
                text: "Total Tax",
                sort: true,
                style: {
                    textAlign: 'right',
                },
                export: true,
                footer: (columnData) => columnData.reduce((acc, item) => acc + item, 0).toLocaleString('en-GB'),
                footerFormatter: footerFormatter,
                headerStyle: (colum, colIndex) => {
                    return { width: "100px", fontSize: "13px" };
                },
            },
            {
                dataField: "netPayable",
                text: "Net Payable",
                sort: true,
                style: {
                    textAlign: 'right',
                },
                export: true,
                footer: (columnData) => columnData.reduce((acc, item) => acc + item, 0).toLocaleString('en-GB'),
                footerFormatter: footerFormatter,
                headerStyle: (colum, colIndex) => {
                    return { width: "100px", fontSize: "13px" };
                },
            },
            //{
            //    dataField: "filerStatus",
            //    text: "Filer Status",
            //    sort: true,
            //    export: true,
            //    headerStyle: (colum, colIndex) => {
            //        return { width: "100px", fontSize: "13px" };
            //    },
            //},
            {
                dataField: "bankName",
                text: "Bank Name",
                sort: true,
                export: true,
                headerStyle: (colum, colIndex) => {
                    return { width: "100px", fontSize: "13px" };
                },
            },
            {
                dataField: "imdCode",
                text: "IMD Code",
                sort: true,
                export: true,
                headerStyle: (colum, colIndex) => {
                    return { width: "100px", fontSize: "13px" };
                },
            },
            {
                dataField: "accountNumber",
                text: "Account",
                sort: true,
                export: true,
                headerStyle: (colum, colIndex) => {
                    return { width: "200px", fontSize: "13px" };
                },
            }

        ];


        const selectRow = {
            mode: 'checkbox',
            clickToSelect: true,
            selected: this.state.selectedRows,
            onSelect: (row, isSelect, rowIndex, e) => {
                const { selectedRows } = this.state;

                if (isSelect) {
                    this.setState({ selectedRows: [...selectedRows, row.hcfId] });
                } else {
                    this.setState({
                        selectedRows: selectedRows.filter((selectedId) => selectedId !== row.hcfId),
                    });
                }
            },
            style: { backgroundColor: '#c8e6c9' }
        };

        return (
            <div>
                <AlertModal {...this.state.alertModalData} />
                <MainLayout />
                <div id="right-panel" className="right-panel">
                    <Topmenu
                        PageTitle="Finance"
                        isShowAddBtn={this.state.permissions.includes("riderprofiles-add")}
                        AddBtnLabel=""
                        AddBtnLink=""
                    />
                    <div className="content">
                        <div
                            className="card"
                            style={{
                                marginBottom: "20px",
                                background: "none",
                                boxShadow: "none",
                            }}
                        >
                            <div className="card-body row" style={{ padding: "0px" }}>
                                <div className="widget-tabs-list">
                                    <ul className="Cases-nav nav nav-tabs">
                                        <li>
                                            {" "}
                                            {this.state.permissions.includes("jobhistory-view") && (
                                                <Link data-toggle="tab" to="/HcfIncentives" className="active">
                                                    HCF Incentives
                                                </Link>
                                            )}
                                        </li>

                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div className="card">
                            <div className="card-body">
                                <div className="Table_Search row">
                                    <div className="formInput_Container Search_InputSelectContainer col-lg-3 col-md-3 col-sm-12 col-xs-12">
                                        <label htmlFor="">Province</label>
                                        <DropDown
                                            multi={true}
                                            dropdownRenderer={true}
                                            create={false}
                                            onChange={this.HandleAutoSuggestValChange}
                                            Type="ProvinceId"
                                            options={this.state.Provincelist}
                                            val={this.state.ProvinceId}
                                            addPlaceholder=""
                                            disabled={false}
                                            loading={this.state.ProvinceLoader}
                                            searchBy="name"
                                            labelField="name"
                                            valueField="id"
                                            contentRenderer={true}
                                            placeholder="Select"
                                        />
                                    </div>

                                    <div className="formInput_Container col-lg-3 col-md-3 col-sm-12 col-xs-12">
                                        <label htmlFor="">Sub Recipient</label>
                                        <DropDown
                                            ValueType={false}
                                            multi={true}
                                            dropdownRenderer={true}
                                            create={false}
                                            onChange={this.HandleAutoSuggestValChange}
                                            Type="SrId"
                                            options={this.state.FilteredSrs}
                                            val={this.state.SrId}
                                            addPlaceholder=""
                                            disabled={false}
                                            searchBy="name"
                                            labelField="name"
                                            valueField="id"
                                            contentRenderer={true}
                                            placeholder="Select"
                                        />
                                    </div>

                                    <div className="formInput_Container Search_InputSelectContainer col-lg-3 col-md-3 col-sm-12 col-xs-12">
                                        <label htmlFor="">District</label>
                                        <DropDown
                                            multi={true}
                                            dropdownRenderer={true}
                                            create={false}
                                            onChange={this.HandleAutoSuggestValChange}
                                            Type="DistrictId"
                                            options={this.state.FilteredDistrictlist}
                                            val={this.state.DistrictId}
                                            addPlaceholder=""
                                            disabled={false}
                                            loading={this.state.DistrictLoader}
                                            searchBy="name"
                                            labelField="name"
                                            valueField="id"
                                            contentRenderer={true}
                                            placeholder="Select"
                                        />
                                    </div>

                                    <div className="formInput_Container Search_InputSelectContainer col-lg-3 col-md-3 col-sm-12 col-xs-12">
                                        <label htmlFor="">Tehsil</label>
                                        <DropDown
                                            multi={true}
                                            dropdownRenderer={true}
                                            create={false}
                                            onChange={this.HandleAutoSuggestValChange}
                                            Type="TehsilId"
                                            options={this.state.FilteredTehsillist}
                                            val={this.state.TehsilId}
                                            addPlaceholder=""
                                            disabled={false}
                                            loading={this.state.TehsilLoader}
                                            searchBy="name"
                                            labelField="name"
                                            valueField="id"
                                            contentRenderer={true}
                                            placeholder="Select"
                                        />
                                    </div>

                                    <div className="formInput_Container col-lg-3 col-md-3 col-sm-12 col-xs-12">
                                        <label htmlFor="">From Date</label>
                                        <DatePicker
                                            selected={this.state.startDate}
                                            onChange={(date) => this.HandleDateChange("startDate", date)}
                                            className="form-control"
                                            dateFormat="dd/MM/yyyy"
                                            placeholderText="Select From Date"
                                            peekNextMonth
                                            showMonthDropdown
                                            showYearDropdown
                                            dropdownMode="select"
                                            maxDate={new Date()}
                                        />
                                    </div>

                                    <div className="formInput_Container col-lg-3 col-md-3 col-sm-12 col-xs-12">
                                        <label htmlFor="">To Date</label>
                                        <DatePicker
                                            selected={this.state.endDate}
                                            onChange={(date) => this.HandleDateChange("endDate", date)}
                                            className="form-control"
                                            dateFormat="dd/MM/yyyy"
                                            placeholderText="Select To Date"
                                            peekNextMonth
                                            showMonthDropdown
                                            showYearDropdown
                                            dropdownMode="select"
                                            minDate={this.state.startDate}
                                            maxDate={new Date()}
                                        />
                                    </div>

                                    <div className="formInput_Container col-lg-3 col-md-2 col-sm-12 col-xs-12">
                                        <label htmlFor="">Hcf Info</label>
                                        <input
                                            type="text"
                                            id="hcf_info"
                                            className="form-control"
                                            placeholder="Name/CNIC/Contact"
                                            ref={this.hcfInfoRef}
                                        />
                                    </div>

                                    <div className="formInput_Container col-lg-3 col-md-3 col-sm-12 col-xs-12">
                                        <button
                                            style={{ position: "relative", marginTop: 35 }}
                                            onClick={() => {
                                                this.PopulateTable();
                                            }}
                                            id="FormSearchBtn"
                                            className="btn btn_style1"
                                        >
                                            Search
                                        </button>
                                    </div>
                                </div>

                                <Table
                                    keyField="hcfId"
                                    data={this.state.data}
                                    page={this.state.page}
                                    sizePerPage={this.state.sizePerPage}
                                    totalSize={this.state.TotalRecord}
                                    onTableChange={this.handleTableChange}
                                    changeSizePerPage={(size) => {
                                        setTimeout(() => {
                                            this.ExportData();
                                        }, 100);
                                    }}
                                    exportPdf={this.ExportPdf}
                                    isPagination={true}
                                    exportLoading={this.state.exportLoading}
                                    pdfExportLoading={this.state.pdfExportLoading}
                                    columns={columns}
                                    exportAllowed={this.state.permissions.includes(
                                        "riderprofiles-export"
                                    )}
                                    loading={this.state.loading}
                                    RefreshTable={this.PopulateTable}
                                    selectRow={selectRow}
                                />
                            </div>
                        </div>

                        <div className="card">
                            <div className="card-body">
                                <div class="form-inline">
                                    <div class="form-group">
                                        <label htmlFor="staticEmail2" class="sr-only">Batch</label>
                                        <input
                                            type="text"
                                            id="batch"
                                            className="form-control"
                                            placeholder="Batch"
                                            ref={this.batchRef}
                                        />
                                    </div>
                                    <button
                                        onClick={() => {
                                            // Get the batch value from the input reference
                                            const batchValue = this.batchRef.current.value;

                                            // Check if the batch value is empty or whitespace
                                            if (!batchValue.trim()) {
                                                alert('Please enter a Batch value'); // You can use a more sophisticated UI for validation
                                                return;
                                            }

                                            this.PopulateTable();
                                        }}
                                        id="SubmitPaymentsBtn"
                                        className="btn bnt-success"
                                    >
                                        Submit Payments
                                    </button>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        );
    }

    //componentWillMount() {

    //}

    componentDidMount() {
        if (this.props.UserAuthentication.AuthToken === "") {
            this.props.history.push("/Login");
        }

        Common.AddClassToMenueLink(
            "MenuLink_HcfIncentives",
            true,
            "MenuParentLink_Finance"
        );

        this.GetPageConfigData(() => {
            this.PopulateTable();
        });
        Common.Ajax(
            this.props.UserAuthentication.AuthToken,
            "Get",
            false,
            Common.APILinks.SelectAll_RolesPermissions,
            {},
            (resp) => {
                const modifiedPermissions = resp.data
                    .filter(
                        (p) => p.permissioN_GROUP === "RiderJobs" && p.permissioN_ALLOWED
                    )
                    .map((d) => d.permissioN_NAME);
                this.setState({ permissions: modifiedPermissions });
            }
        );
        this.SelectSubReciepents();
    }

    SelectSubReciepents = () => {
        Common.Ajax(
            this.props.UserAuthentication.AuthToken,
            "GET",
            false,
            Common.APILinks.SelectALl_SubRecipient,
            {},
            (resp) => {
                if (resp.status) {
                    this.setState({
                        SrList: resp.data.map((d) => ({
                            id: d.id,
                            name: d.short_name,
                            ...d,
                        })),
                    });
                }
            }
        );
    };

    GetPageConfigData = (CallBack) => {
        this.props.ShowLoader({ Isloading: true });
        var d1 = $.Deferred();
        var d2 = $.Deferred();
        var d3 = $.Deferred();
        var d4 = $.Deferred();
        this.SelectProvinces(() => {
            d1.resolve();
        });
        this.SelectDistricts(() => {
            d2.resolve();
        });
        this.SelectTehsil(() => {
            d3.resolve();
        });
        this.SelectAllBanksList(() => {
            d4.resolve();
        });
        $.when(d1, d2, d3, d4).done(() => {
            this.props.ShowLoader({ Isloading: false });
            CallBack();
        });
    };
    SelectProvinces = (Callback) => {
        this.setState({ ProvinceLoader: true });
        Common.Ajax(
            this.props.UserAuthentication.AuthToken,
            "GET",
            false,
            Common.APILinks.SelectAll_Province,
            {},
            (data) => {
                this.setState({
                    ProvinceLoader: false,
                    Provincelist: data.data,
                });
                Callback();
            },
            (error) => {
                this.setState({ ProvinceLoader: false });
                this.props.ShowAlert({ Type: 0, Msg: error });
                setTimeout(function () {
                    $("#Alertmsgbtn").click();
                }, 50);
                Callback();
            }
        );
    };
    SelectDistricts = (Callback) => {
        this.setState({ DistrictLoader: true });
        Common.Ajax(
            this.props.UserAuthentication.AuthToken,
            "GET",
            false,
            Common.APILinks.SelectAll_District,
            {},
            (data) => {
                this.setState({
                    DistrictLoader: false,
                    Districtlist: data.data.sort(Common.compare),
                });
                Callback();
            },
            (error) => {
                this.setState({ DistrictLoader: false });
                this.props.ShowAlert({ Type: 0, Msg: error });
                setTimeout(function () {
                    $("#Alertmsgbtn").click();
                }, 50);
                Callback();
            }
        );
    };
    SelectTehsil = (Callback) => {
        this.setState({ TehsilLoader: true });
        Common.Ajax(
            this.props.UserAuthentication.AuthToken,
            "GET",
            false,
            Common.APILinks.SelectAll_Tehsil,
            {},
            (data) => {
                this.setState({
                    TehsilLoader: false,
                    Tehsillist: data.data.sort(Common.compare),
                });
                Callback();
            },
            (error) => {
                this.setState({ TehsilLoader: false });
                this.props.ShowAlert({ Type: 0, Msg: error });
                setTimeout(function () {
                    $("#Alertmsgbtn").click();
                }, 50);
                Callback();
            }
        );
    };
    SelectAllBanksList = (Callback) => {
        this.setState({ BankLoader: true });
        Common.Ajax(
            this.props.UserAuthentication.AuthToken,
            "Get",
            false,
            Common.APILinks.SelectAll_Bank,
            null,
            (resp) => {
                $("#FormSearchBtn").prop("disabled", false);
                if (resp.status) {
                    this.setState({
                        BankLoader: false,
                        Banklist: resp.data,
                    });
                    Callback();
                }
            },
            (error) => {
                this.setState({ BankLoader: false });
                this.props.ShowAlert({ Type: 0, Msg: error });
                setTimeout(function () {
                    $("#Alertmsgbtn").click();
                }, 50);
                Callback();
            }
        );
    };

    ExportPdf = () => {
        const doc = new jsPDF();

        $("#FormSearchBtn").prop("disabled", true);
        this.setState({ pdfExportLoading: true });

        var provinceIdString =
            this.state.ProvinceId.length === 0
                ? ""
                : "," + Common.convertToCommaString(this.state.ProvinceId, "id") + ",";
        var districtIdString =
            this.state.DistrictId.length === 0
                ? ""
                : "," + Common.convertToCommaString(this.state.DistrictId, "id") + ",";
        var tehsilIdString =
            this.state.TehsilId.length === 0
                ? ""
                : "," + Common.convertToCommaString(this.state.TehsilId, "id") + ",";
        var subRecipientIdString =
            this.state.SrId.length === 0
                ? ""
                : "," + Common.convertToCommaString(this.state.SrId, "id") + ",";

        var Parameters = {
            provinceIdString,
            districtIdString,
            tehsilIdString,
            subRecipientIdString,
            month: '2025-05',
            fromDate:
                this.state.startDate == null || this.state.startDate === ""
                    ? null
                    : Common.ConvertToUtcDateTime(
                        Common.getOnlyDate(this.state.startDate) + " 00:00:00"
                    ),
            toDate:
                this.state.endDate == null || this.state.endDate === ""
                    ? null
                    : Common.ConvertToUtcDateTime(
                        Common.getOnlyDate(this.state.endDate) + " 23:59:59"
                    ),
            pageSize: this.state.TotalRecord,
            pageNumber: 1,
            srDistrictIds: this.props.UserAuthentication?.UserInfo?.srDistrictIds,
            sortField: this.state.sortField,
            sortOrder: this.state[this.state.sortField + "sortOrder"],
        };
        Common.Ajax(
            this.props.UserAuthentication.AuthToken,
            "Get",
            false,
            Common.APILinks.Select_MultipleRiderProfiles,
            Parameters,
            (resp) => {
                $("#FormSearchBtn").prop("disabled", false);
                if (resp.status) {
                    doc.autoTable({
                        theme: "grid",
                        body: [...resp.data],
                        columns: [
                            { header: "id", dataKey: "id" },
                            { header: "Name", dataKey: "name" },
                            { header: "Address", dataKey: "address" },
                            { header: "Contact", dataKey: "contact" },
                            { header: "Account #", dataKey: "accountNumber" },
                            { header: "Bank", dataKey: "bankName" },
                            { header: "Province", dataKey: "provinceName" },
                            { header: "Tehsil", dataKey: "tehsilName" },
                            { header: "District", dataKey: "districtName" },
                        ],
                    });

                    this.setState({ pdfExportLoading: false });
                    doc.save("profiles.pdf");
                }
            },
            (error) => {
                $("#FormSearchBtn").prop("disabled", false);
                this.setState({ loading: false });
                this.props.ShowAlert({
                    Type: 0,
                    Msg: "Something went wrong, please try again.",
                });
                setTimeout(function () {
                    $("#Alertmsgbtn").click();
                }, 50);
            }
        );
    };

    ExportData = (size) => {
        $("#FormSearchBtn").prop("disabled", true);
        this.setState({ exportLoading: true, loading: true });

        var provinceId =
            this.state.ProvinceId.length === 0
                ? ""
                : "," + Common.convertToCommaString(this.state.ProvinceId, "id") + ",";
        var districtId =
            this.state.DistrictId.length === 0
                ? ""
                : "," + Common.convertToCommaString(this.state.DistrictId, "id") + ",";
        var tehsilId =
            this.state.TehsilId.length === 0
                ? ""
                : "," + Common.convertToCommaString(this.state.TehsilId, "id") + ",";
        var subRecipientIdString =
            this.state.SrId.length === 0
                ? ""
                : "," + Common.convertToCommaString(this.state.SrId, "id") + ",";

        var Parameters = {
            provinceId,
            districtId,
            tehsilId,
            subRecipientIdString,
            pageSize: this.state.TotalRecord || 10000,
            pageNumber: 1,
            srDistrictIds: this.props.UserAuthentication?.UserInfo?.srDistrictIds,
            sortField: this.state.sortField,
            hcfInfo: this.hcfInfoRef.current.value,
            fromDate:
                this.state.startDate == null || this.state.startDate === ""
                    ? null
                    : Common.ConvertToUtcDateTime(
                        Common.getOnlyDate(this.state.startDate) + " 00:00:00"
                    ),
            toDate:
                this.state.endDate == null || this.state.endDate === ""
                    ? null
                    : Common.ConvertToUtcDateTime(
                        Common.getOnlyDate(this.state.endDate) + " 23:59:59"
                    ),
            batch: this.batchRef.current.value,
            selectedIds: this.state.selectedRows,
            sortOrder: this.state[this.state.sortField + "sortOrder"],
        };
        Common.Ajax(
            this.props.UserAuthentication.AuthToken,
            "Get",
            false,
            Common.APILinks.HcfIncentives_SelectAll,
            Parameters,
            (resp) => {
                $("#FormSearchBtn").prop("disabled", false);
                this.setState({ loading: false });
                if (resp.status) {
                    // Transform the data to split persons into separate rows
                    const transformedData = [];
                    resp.data.forEach(row => {
                        // Split focal persons, contact numbers, and CNICs
                        const focalPersons = row.focalPerson ? row.focalPerson.split(',').map(p => p.trim()) : [];
                        const contactNos = row.contactNo ? row.contactNo.split(',').map(c => c.trim()) : [];
                        const cnics = row.cnic ? row.cnic.split(',').map(c => c.trim()) : [];

                        // Create a row for each person
                        const maxLength = Math.max(focalPersons.length, contactNos.length, cnics.length);

                        // If no persons to split (all null/empty), create single row
                        if (maxLength === 0) {
                            transformedData.push({
                                ...row,
                                focalPerson: '',
                                contactNo: '',
                                cnic: ''
                            });
                        } else {
                            // Create a row for each person
                            for (let i = 0; i < maxLength; i++) {
                                transformedData.push({
                                    ...row,
                                    focalPerson: focalPersons[i] || '',
                                    contactNo: contactNos[i] || '',
                                    cnic: cnics[i] || ''
                                });
                            }
                        }
                    });

                    // Generate filename with dates
                    const fromDateStr = Common.getOnlyDate(this.state.startDate).replace(/\//g, '-');
                    const toDateStr = Common.getOnlyDate(this.state.endDate).replace(/\//g, '-');
                    const filename = `HCF_Incentives_${fromDateStr}_to_${toDateStr}.csv`;

                    // Generate CSV manually with custom filename
                    this.generateAndDownloadCSV(transformedData, filename);

                    // Reset state and reload original table data
                    this.setState({
                        exportLoading: false,
                    });

                    setTimeout(() => {
                        this.PopulateTable();
                    }, 500);
                } else {
                    this.setState({ exportLoading: false });
                    this.props.ShowAlert({ Type: 0, Msg: resp.message });
                    setTimeout(function () {
                        $("#Alertmsgbtn").click();
                    }, 50);
                }
            },
            (error) => {
                $("#FormSearchBtn").prop("disabled", false);
                this.setState({
                    loading: false,
                    exportLoading: false,
                });
                this.props.ShowAlert({
                    Type: 0,
                    Msg: "Something went wrong, please try again.",
                });
                setTimeout(function () {
                    $("#Alertmsgbtn").click();
                }, 50);
            }
        );
    };

    generateAndDownloadCSV = (data, filename) => {
        // Get columns configuration from render method
        const columns = [
            { dataField: 'srNo', text: 'Sr. #', export: true },
            { dataField: 'provinceName', text: 'Province', export: true },
            { dataField: 'districtName', text: 'District', export: true },
            { dataField: 'subRecipientShortName', text: 'SR', export: true },
            { dataField: 'hcfName', text: 'Health Care Facilities (HCF)', export: true },
            { dataField: 'category', text: 'Category', export: true },
            { dataField: 'focalPerson', text: 'Focal Person', export: true },
            { dataField: 'contactNo', text: 'Contact #', export: true },
            { dataField: 'cnic', text: 'CNIC', export: true },
            { dataField: 'bpuGpSamples', text: 'Samples by GP & BHU', export: true },
            { dataField: 'ppmRhcSamples', text: 'Samples by PPM & RHC', export: true },
            { dataField: 'afbHcfTestResults', text: 'AFB by HCF for GP & BHU', export: true },
            { dataField: 'afbXpertTestResults', text: 'AFB by GX Sites for GP & BHU', export: true },
            { dataField: 'gxTestResults', text: 'GX Test Results', export: true },
            { dataField: 'totalSamplesAndTestResults', text: 'Total Samples And Test Results', export: true },
            { dataField: 'totalIncentiveSampleOrTestResult', text: 'Total Incentive Sample Or Test Result', export: true },
            { dataField: 'withholdingTax', text: 'WHT @ 8%/4%', export: true },
            { dataField: 'gst', text: 'GST @ 5%', export: true },
            { dataField: 'totalTaxes', text: 'Total Tax', export: true },
            { dataField: 'netPayable', text: 'Net Payable', export: true },
            { dataField: 'bankName', text: 'Bank Name', export: true },
            { dataField: 'imdCode', text: 'IMD Code', export: true },
            { dataField: 'accountNumber', text: 'Account', export: true },
        ];

        // Filter only exportable columns
        const exportableColumns = columns.filter(col => col.export);

        // Generate CSV header
        const headers = exportableColumns.map(col => `"${col.text}"`).join(',');

        // Generate CSV rows
        const rows = data.map((row, index) => {
            return exportableColumns.map(col => {
                let value = '';

                // Handle Sr. # field
                if (col.dataField === 'srNo') {
                    value = index + 1;
                } else {
                    value = row[col.dataField] !== null && row[col.dataField] !== undefined
                        ? row[col.dataField]
                        : '';
                }

                // Escape and format value for CSV
                if (typeof value === 'string') {
                    // Escape quotes and wrap in quotes if contains comma, newline, or quote
                    value = value.replace(/"/g, '""');
                    if (value.includes(',') || value.includes('\n') || value.includes('"')) {
                        return `"${value}"`;
                    }
                    return `"${value}"`;
                } else if (typeof value === 'number') {
                    return value;
                }
                return `"${value}"`;
            }).join(',');
        }).join('\n');

        // Combine header and rows
        const csv = headers + '\n' + rows;

        // Create blob and download
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);

        link.setAttribute('href', url);
        link.setAttribute('download', filename);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    handleTableChange = (
        type,
        { page, sizePerPage, filters, sortField, sortOrder, cellEdit }
    ) => {
        if (type == "sort") {
            // Since we've disabled frontend sorting, we need to handle this manually
            // We'll still track the sort state and make API calls
            let tempFieldorderLabel = sortField + "sortOrder";
            let tempFieldorder =
                this.state[tempFieldorderLabel] == ""
                    ? sortOrder
                    : this.state[tempFieldorderLabel] == "asc"
                        ? "desc"
                        : "asc";
            this.setState(
                {
                    sortField,
                    [tempFieldorderLabel]: tempFieldorder,
                },
                () => {
                    this.PopulateTable();
                }
            );
            return;
        }
        this.setState(
            {
                page,
                sizePerPage,
            },
            () => {
                this.PopulateTable();
            }
        );
    };
    PopulateTable = () => {
        $("#FormSearchBtn").prop("disabled", true);
        this.setState({ loading: true, data: [], TotalRecord: 0 });

        var provinceId =
            this.state.ProvinceId.length === 0
                ? ""
                : "," + Common.convertToCommaString(this.state.ProvinceId, "id") + ",";
        var districtId =
            this.state.DistrictId.length === 0
                ? ""
                : "," + Common.convertToCommaString(this.state.DistrictId, "id") + ",";
        var tehsilId =
            this.state.TehsilId.length === 0
                ? ""
                : "," + Common.convertToCommaString(this.state.TehsilId, "id") + ",";
        var subRecipientIdString =
            this.state.SrId.length === 0
                ? ""
                : "," + Common.convertToCommaString(this.state.SrId, "id") + ",";


        var Parameters = {
            provinceId,
            districtId,
            tehsilId,
            subRecipientIdString,
            pageSize: this.state.sizePerPage,
            pageNumber: this.state.page,
            srDistrictIds: this.props.UserAuthentication?.UserInfo?.srDistrictIds,
            sortField: this.state.sortField,
            hcfInfo: this.hcfInfoRef.current.value,
            fromDate:
                this.state.startDate == null || this.state.startDate === ""
                    ? null
                    : Common.ConvertToUtcDateTime(
                        Common.getOnlyDate(this.state.startDate) + " 00:00:00"
                    ),
            toDate:
                this.state.endDate == null || this.state.endDate === ""
                    ? null
                    : Common.ConvertToUtcDateTime(
                        Common.getOnlyDate(this.state.endDate) + " 23:59:59"
                    ),
            batch: this.batchRef.current.value,
            selectedIds: this.state.selectedRows,
            sortOrder: this.state[this.state.sortField + "sortOrder"],
        };
        Common.Ajax(
            this.props.UserAuthentication.AuthToken,
            "Get",
            false,
            Common.APILinks.HcfIncentives_SelectAll,
            Parameters,
            (resp) => {
                $("#FormSearchBtn").prop("disabled", false);
                this.setState({ loading: false });
                if (resp.status) {
                    // Transform the data to split persons into separate rows
                    const transformedData = [];
                    resp.data.forEach(row => {
                        // Split focal persons, contact numbers, and CNICs
                        const focalPersons = row.focalPerson ? row.focalPerson.split(',').map(p => p.trim()) : [];
                        const contactNos = row.contactNo ? row.contactNo.split(',').map(c => c.trim()) : [];
                        const cnics = row.cnic ? row.cnic.split(',').map(c => c.trim()) : [];

                        // Create a row for each person
                        const maxLength = Math.max(focalPersons.length, contactNos.length, cnics.length);

                        // If no persons to split (all null/empty), create single row
                        if (maxLength === 0) {
                            const newRow = {
                                ...row,
                                focalPerson: '',
                                contactNo: '',
                                cnic: ''
                            };
                            transformedData.push(newRow);
                        } else {
                            // Create a row for each person
                            for (let i = 0; i < maxLength; i++) {
                                const newRow = {
                                    ...row,
                                    focalPerson: focalPersons[i] || '',
                                    contactNo: contactNos[i] || '',
                                    cnic: cnics[i] || ''
                                };
                                transformedData.push(newRow);
                            }
                        }
                    });

                    if (this.batchRef && this.batchRef.current.value.length) {
                        this.props.ShowAlert({
                            Type: 0,
                            Msg: "Payments saved successfully",
                        });

                        setTimeout(function () {
                            $("#Alertmsgbtn").click();
                        }, 50);
                    }

                    this.setState({
                        data: transformedData,
                        TotalRecord: transformedData.length,
                    });
                } else {
                    this.props.ShowAlert({ Type: 0, Msg: resp.message });
                    setTimeout(function () {
                        $("#Alertmsgbtn").click();
                    }, 50);
                }

                this.batchRef.current.value = '';
            },
            (error) => {
                $("#FormSearchBtn").prop("disabled", false);
                this.setState({ loading: false });
                this.props.ShowAlert({
                    Type: 0,
                    Msg: "Something went wronge, please try again.",
                });
                setTimeout(function () {
                    $("#Alertmsgbtn").click();
                }, 50);

                this.batchRef.current.value = '';
            }
        );
    };


}

export default connect(mapStateToProps, mapDispatchToProps)(HcfIncentives);
